import { OXBURY_CODE } from 'appConstants';
import { t } from 'i18next';
import type { IGenericObject } from 'types';
import * as yup from 'yup';
import type { IValidationField } from '../types';

/**
 * @param fieldContext
 * Dependency: paymentTermsCode field
 */

export default function businessUser({ context: fieldContext = {} }: IValidationField) {
  const { labels } = fieldContext;
  return yup
    .object()
    .shape({
      name: yup.string().test({
        name: 'required_business_name',
        test: (name, context) => {
          const {
            options: { from },
            path,
          } = context as IGenericObject;
          const [
            ,
            {
              value: { paymentTerms: { paymentTermsCode = '', isOxbury = false } = {} },
            },
          ] = from;

          if (paymentTermsCode && !name && (isOxbury || paymentTermsCode.startsWith(OXBURY_CODE))) {
            return context.createError({
              message: t('errors.required', {
                label: labels?.businessName,
              }),
              path,
            });
          }

          return true;
        },
      }),
      contactNumber: yup.string().test({
        name: 'required_business_contact',
        test: (name, context) => {
          const {
            options: { from },
            path,
          } = context as IGenericObject;
          const [
            ,
            {
              value: { paymentTerms: { paymentTermsCode = '', isOxbury = false } = {} },
            },
          ] = from;

          if (paymentTermsCode && !name && (isOxbury || paymentTermsCode.startsWith(OXBURY_CODE))) {
            return context.createError({
              message: t('errors.required', {
                label: labels?.businessContact,
              }),
              path,
            });
          }

          return true;
        },
      }),
    })
    .default({});
}
